import { AttributeTypeEnumType } from '@mark43/rms-api';
import { noop } from 'lodash';
import { ComponentPropsWithoutRef } from 'react';
import { useAttributeOptionsByType } from '../../attributes/use-attribute-options-by-type';
import { adaptSelectOnChange } from '../helpers/adapt-select-on-change';
import { BaseSelect } from './base-select';

interface AttributeSelectProps
    extends Omit<ComponentPropsWithoutRef<typeof BaseSelect>, 'options' | 'isLoading'> {
    attributeType: AttributeTypeEnumType;
    includeDisplayAbbreviation?: boolean;
}

export const AttributeSelect: React.FC<AttributeSelectProps> = ({
    attributeType,
    includeDisplayAbbreviation = false,
    ...rest
}) => {
    const { attributeOptions, isInitialLoading } = useAttributeOptionsByType({
        attributeType,
        includeDisplayAbbreviation,
    });
    return (
        <BaseSelect
            options={attributeOptions}
            isLoading={isInitialLoading}
            {...rest}
            onChange={adaptSelectOnChange(rest.onChange ?? noop, attributeOptions)}
        />
    );
};
